export default "__VITE_ASSET__5b1ca7db__"